import useTranslation from "../../hooks/useTranslation";
import { fullDateTimeFormat } from "../../utils/helpers";
import { Avatar } from "./Avatar";

import style from "./CommentHeader.module.css";

interface CommentHeaderProps {
  name: string;
  commentedAt: string;
  actions?: React.ReactNode;
}

export const CommentHeader = ({ name, commentedAt, actions }: CommentHeaderProps) => {
  const { formatDate } = useTranslation();
  return (
    <div className={style.header}>
      <Avatar title={name} />
      <div className={style.info}>
        <div className={style.name}>{name}</div>
        <div className={style.date}>{formatDate(new Date(commentedAt), fullDateTimeFormat)}</div>
      </div>
      <div className={style.actions}>{actions}</div>
    </div>
  );
};
